module.exports = __webpack_public_path__ + "media/img/apple-icon-57x57-0bc7cd47caebcc7e837cfdbcd119a4bf.png";